"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.octDocs = void 0;
var octDocs = exports.octDocs = {
  name: 'oct',
  category: 'Utils',
  syntax: ['oct(value)'],
  description: 'Format a number as octal',
  examples: ['oct(56)'],
  seealso: ['bin', 'hex']
};